<template>
    <div>
        <div style="height:50px; background-color: rgba(0,0,0,0.3);"></div>
        <div style="flex:1; background-color: rgba(0,0,0,0.3);">
            <div style="height:100%; background-color:white; border-top-left-radius: 12px; border-top-right-radius:12px; padding:0px 20px;">
                <div style="height:55px; display:flex; align-items: center;">
                    <div style="width:60px;height:100%; display:grid; place-items: center; color:#808080; font-size:16px; font-weight:bold;" @click="() => {$GlobalStore.closeLastModal()}">닫기</div>
                    <div style="flex:1;"></div>
                    <div style="width:60px;"></div>
                </div>
                <template v-if="accountInfo && accountInfo.reg_date">
                    <div style="text-align:center; margin-top:40px;">
                        <img :src="require('@/assets/img/find_account_exist.png')" style="width:113px;">
                    </div>
                    <div style="font-size: 16px; color:#210F03; text-align:center; margin-top:20px;">동일한 번호로 가입된 계정을 찾았습니다.</div>
                    <div style="color:#606060; font-size:12px; margin-top:20px;">{{accountInfo.reg_date ? $Util.getYYYMMDDHangulStr(accountInfo.reg_date): ''}} 가입</div>
                    <div style="height:48px; background-color:#F5F5F5; display:flex; align-items: center; padding:0px 12px; border-radius:12px; margin-top:4px;" @click="login">
                        <div style="flex:1; color:#210F03; font-size:16px;">{{accountInfo.id}}</div>
                        <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; height:15px;">
                    </div>
                    <div style="text-align:right; font-size:14px; color:var(--color-main); margin-top:5px;">눌러서 바로 로그인하기</div>
                </template>
                <template v-else>
                    <div style="text-align:center; margin-top:40px;">
                        <img :src="require('@/assets/img/find_account_none.png')" style="width:113px;">
                    </div>
                    <div style="font-size: 16px; color:#210F03; text-align:center; margin-top:20px;">동일한 번호로 가입된 계정이 없습니다.</div>
                    <div style="height:48px; color:var(--color-main);font-weight:bold;;background-color:#F5F5F5; display:grid; place-items: center; padding:0px 12px; border-radius:12px; margin-top:40px;" @click="showRegist">새로운 사커하우 계정 만들기</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FindAccount2",
        props : {
            accountInfo : {
                type : Object,
                default : () => {}
            }
        },
        methods : {
            async login(){
                const parameters = {};
                const device = this.$cookies.get('device');
                if(device === 'android' || device === 'ios'){
                    parameters.pushToken = await window.pushCustomManager.getPushToken();
                    parameters.uuid = await window.pushCustomManager.getUuid();
                }

                parameters.marketingAgree = localStorage.getItem('marketing_agree') ?? '';

                const res = await this.$Axios.post('/api/auth/find/login', parameters);
                if(res.data.code === 0){
                    localStorage.removeItem('marketing_agree');
                    this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                    this.$GlobalStore.closeLastModal(true);
                    this.$GlobalStore.closeLastModal(true);
                    this.$Util.checkAfterLogin(res.data.isSoccerhowWritten);
                }else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            showRegist(){
                this.$GlobalStore.closeLastModal();
                this.$GlobalStore.addModal('MemberRegist', {transitionName: 'bottom' });
            }

        },
        created(){
            this.login = this.$Once(this.login);
            console.log('account Infp : ', this.accountInfo)
        }
    }
</script>

<style scoped>

</style>